import React from 'react';
import { Icon } from '@iconify/react';
import { useResolvedPath, useMatch, useLocation, matchPath, Link, NavLink } from 'react-router-dom';
import menus from './../../config/app-menu.jsx';

function NavItem({ menu, ...props }) {
	let resolved = useResolvedPath(menu.path);
  let match = useMatch({ path: resolved.pathname });
  
  let location = useLocation();
  let match2 = matchPath({path: menu.path, end: false, },location.pathname);
  
	let icon = menu.icon && <div className="menu-icon"><Icon icon={menu.icon} /></div>;
	let img = menu.img && <div className="menu-icon-img"><img src={menu.img} alt="" /></div>;
	let caret = (menu.children && !menu.badge) && <div className="menu-caret"></div>;
	let label = menu.label && <span className="menu-label ms-5px">{menu.label}</span>;
	let badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
	let highlight = menu.highlight && <i className="fa fa-paper-plane text-theme"></i>;
	let title = menu.title && <div className="menu-text">{menu.title} {label} {highlight}</div>;
	let menuLink = menu.children ? (
		<a href="#/" className="menu-link">{ img } { icon } { title }{ caret } { badge }</a>
	) : (
		<NavLink className="menu-link" to={menu.path} {...props}>{ img } { icon } { title }{ caret } { badge }</NavLink>
	);
	
	return (
    <div className={'menu-item' + ((match || match2) ? ' active' : '') + (menu.children ? ' has-sub' : '')}>
	    	{menuLink}
			
      {menu.children && (
				<div className="menu-submenu">
					{menu.children.map((submenu, i) => (
						<NavItem key={i} menu={submenu} />
					))}
				</div>
			)}
    </div>
  );
}

function TopNavMenu() {
	function handleMenuButtonAction(elm, direction) {
		var element = elm.target;
		var obj = element.closest('.menu');
		var objStyle = window.getComputedStyle(obj);
		var bodyStyle = window.getComputedStyle(document.querySelector('body'));
		var targetCss = (bodyStyle.getPropertyValue('direction') === 'rtl') ? 'margin-right' : 'margin-left';
		var marginLeft = parseInt(objStyle.getPropertyValue(targetCss));  
		var containerWidth = document.querySelector('.app-top-nav').clientWidth - 80;
		var totalWidth = 0;
		var finalScrollWidth = 0;
	
		var elms = [].slice.call(obj.querySelectorAll('.menu-item'));
		if (elms) {
			elms.map(function(elm) {
				if (!elm.classList.contains('menu-control')) {
					totalWidth += elm.clientWidth;
				}
				return true;
			});
		}

		switch (direction) {
			case 'next':
				var widthNextLeft = totalWidth + marginLeft - containerWidth;
				if (widthNextLeft <= containerWidth) {
					finalScrollWidth = widthNextLeft - marginLeft - 88;
					setTimeout(function() {
						obj.querySelector('.menu-control.menu-control-end').classList.remove('show');
					}, 300);
				} else {
					finalScrollWidth = containerWidth - marginLeft - 88;
				}

				if (finalScrollWidth !== 0) {
					obj.style.transitionProperty = 'height, margin, padding';
					obj.style.transitionDuration = '300ms';
					if (bodyStyle.getPropertyValue('direction') !== 'rtl') {
						obj.style.marginLeft = '-' + finalScrollWidth + 'px';
					} else {
						obj.style.marginRight = '-' + finalScrollWidth + 'px';
					}
					setTimeout(function() {
						obj.style.transitionProperty = '';
						obj.style.transitionDuration = '';
						obj.querySelector('.menu-control.menu-control-start').classList.add('show');
					}, 300);
				}
				break;
			case 'prev':
				var widthPrevLeft = -marginLeft;

				if (widthPrevLeft <= containerWidth) {
					obj.querySelector('.menu-control.menu-control-start').classList.remove('show');
					finalScrollWidth = 0;
				} else {
					finalScrollWidth = widthPrevLeft - containerWidth + 88;
				}
			
				obj.style.transitionProperty = 'height, margin, padding';
				obj.style.transitionDuration = '300ms';
			
				if (bodyStyle.getPropertyValue('direction') !== 'rtl') {
					obj.style.marginLeft = '-' + finalScrollWidth + 'px';
				} else {
					obj.style.marginRight = '-' + finalScrollWidth + 'px';
				}
			
				setTimeout(function() {
					obj.style.transitionProperty = '';
					obj.style.transitionDuration = '';
					obj.querySelector('.menu-control.menu-control-end').classList.add('show');
				}, 300);
				break;
			default:
				break;
			}
	};

	function controlRight(e) {
		e.preventDefault();
		handleMenuButtonAction(e, 'next');
	}

	function controlLeft(e) {
		e.preventDefault();
		handleMenuButtonAction(e, 'prev');
	}

	return (
		<div className="menu">
			{menus.map((menu, i) => (
				<NavItem key={i} menu={menu} />
			))}
			<div className="menu-item menu-control menu-control-start">
				<Link className="menu-link" to="/" onClick={controlLeft}><i className="fa fa-angle-left"></i></Link>
			</div>
			<div className="menu-item menu-control menu-control-end">
				<Link className="menu-link" to="/" onClick={controlRight}><i className="fa fa-angle-right"></i></Link>
			</div>
		</div>
	);
}

export default TopNavMenu;
